(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scField/scColorpickerMiniField/template', '<div class="form_field {{ containerClass || \'full\' }}">\n' + '  <label class="form_label" _spec="label"> {{ label }} </label>\n' + '\n' + '  <p class="form_helper" _spec="helper">{{ description }}</p>\n' + '\n' + '  <div\n' + '    data-sc-spectrum="{{ model }}"\n' + '    data-fallback-color="{{ fallback }}"\n' + '    data-swatch-size="{{ swatchSize || 25 }}"\n' + '  ></div>\n' + '</div>\n' + '');
}]);
})();